<template>
  <v-card class="transparent" flat>
    <v-card-title
      class="px-0"
      :class="
        $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
      "
      >Personalstärke
      <v-spacer></v-spacer>
      <v-btn
        text
        outlined
        small
        :to="{
          name: 'availability-leaves',
        }"
        >Abwesenheiten anzeigen</v-btn
      >
    </v-card-title>
    <v-card>
      <!-- <v-card-title class="subtitle-1 font-weight-medium pt-2"
        >Personalstärke</v-card-title
      > -->
      <v-card-subtitle v-if="leavesAvailabiliy && canReadAllLeaves"
        >Basierend auf eingegangenen Abwesenheitsmeldungen</v-card-subtitle
      >
      <v-card-subtitle v-else-if="!canReadAllLeaves"
        >Keine Berechtigung für detaillierte Ansicht</v-card-subtitle
      >
      <v-card-text>
        <v-row dense>
          <v-col cols="sm">
            <v-card
              class="pa-2 text-h5 font-weight-bold green--text text--darken-4"
              dark
              outlined
              color="green lighten-4"
            >
              <div class="text-center">
                <template v-if="isLoading">
                  <v-progress-circular
                    indeterminate
                    size="24"
                    width="2"
                    color="green darken-4"
                  ></v-progress-circular>
                </template>
                <template v-else>{{ availableMembersCount }}</template>
              </div>
              <div class="font-weight-medium subtitle-2 text-center">
                Verfügbar
              </div>
            </v-card> </v-col
          ><v-col v-if="organization.count.totalInEvent > 0" cols="sm">
            <v-card
              class="pa-2 text-h5 font-weight-bold blue--text text--darken-4"
              dark
              outlined
              color="blue lighten-4"
            >
              <div class="text-center">
                <template v-if="isLoading">
                  <v-progress-circular
                    indeterminate
                    size="24"
                    width="2"
                    color="blue darken-4"
                  ></v-progress-circular>
                </template>
                <template v-else>{{
                  organization.count.totalInEvent
                }}</template>
              </div>
              <div class="font-weight-medium subtitle-2 text-center">
                Bereits gebunden
              </div>
            </v-card> </v-col
          ><v-col cols="sm">
            <v-card
              class="pa-2 text-h5 font-weight-bold red--text text--darken-4"
              dark
              outlined
              color="red lighten-4"
            >
              <div class="text-center">
                <template v-if="isLoading">
                  <v-progress-circular
                    indeterminate
                    size="24"
                    width="2"
                    color="red darken-4"
                  ></v-progress-circular>
                </template>
                <template v-else>{{ activeLeavesCount }}</template>
              </div>
              <div class="font-weight-medium subtitle-2 text-center">
                Nicht verfügbar
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider v-if="unitsAvailability && units.length > 0"></v-divider>
      <v-card-title
        v-if="unitsAvailability && units.length > 0"
        class="subtitle-1 font-weight-medium pb-0"
        >Einsatzmittel</v-card-title
      >
      <v-card-subtitle v-if="unitsAvailability && units.length > 0"
        >Basierend auf Fahrzeugstatus und verfügbaren
        Funktionen</v-card-subtitle
      >
      <v-card-text v-if="unitsAvailability && units.length > 0">
        <v-row dense>
          <v-col v-for="unit in units" :key="unit.id" cols="4">
            <v-card outlined>
              <v-img
                :src="unit.photoUrl"
                contain
                height="80px"
                class="mx-4"
              ></v-img>
              <div
                :class="[
                  'align-end subtitle-2 font-weight-medium text-center text--darken-4',
                  statusTextColor(unit.status),
                  statusColor(unit.status),
                ]"
              >
                <span class="caption">{{ unit.callsign }}</span>
                <br />
                {{ statusText(unit.status) }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider
        v-if="positionsAvailability && positions.length > 0"
      ></v-divider>
      <v-card-title
        v-if="positionsAvailability && positions.length > 0"
        class="subtitle-1 font-weight-medium pb-0"
        >Funktionen</v-card-title
      >
      <v-card-subtitle v-if="positionsAvailability && positions.length > 0"
        >Basierend auf verfügbaren Qualifikationen</v-card-subtitle
      >
      <v-card-text v-if="positionsAvailability && positions.length > 0">
        <v-row dense>
          <v-col v-for="position in positions" :key="position.id" cols="3">
            <v-card
              :class="[
                'pa-2 text-h5 font-weight-bold text--darken-4 green--text',
                statusTextColor(position.status),
              ]"
              dark
              outlined
              color="green lighten-4"
            >
              <div class="text-center">
                {{ position.count }}
              </div>
              <div class="font-weight-medium subtitle-2 text-center">
                {{ position.callsign }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import { db1 } from "@/firebase";
import {
  collection,
  query,
  where,
  Timestamp,
  getCountFromServer,
} from "firebase/firestore";
import { AVAILABILITY_LEAVES_read_all } from "@/data/permission-types.js";

export default {
  name: "availability-status-overview-card",
  props: {},
  data() {
    return {
      isLoading: true,
      activeLeavesCount: 0,
      totalActiveMembersCount: 0,
      units: [
        {
          callsign: "LHF XX01/3",
          photoUrl: "",
          status: "operational",
        },
      ],
      positions: [
        {
          callsign: "FzF",
          count: "4",
        },
        {
          callsign: "Ma (+C)",
          count: "4",
        },
        {
          callsign: "TF",
          count: "4",
        },
        {
          callsign: "TL",
          count: "4",
        },
      ],
    };
  },
  computed: {
    organization() {
      return this.$store.state.organization.activeOrganization;
    },
    leavesAvailabiliy() {
      return this.$store.getters["organization/checkExtensionAvailabilityById"](
        "availability.leaves",
      );
    },
    canReadAllLeaves() {
      return this.$store.getters["organization/checkPermissionByID"](
        `${AVAILABILITY_LEAVES_read_all}`,
      );
    },
    availableMembersCount() {
      const available = this.totalActiveMembersCount - this.activeLeavesCount;
      return Math.max(0, available);
    },
    unitsAvailability() {
      // return this.$store.getters["organization/checkExtensionAvailabilityById"](
      //   "availability.units"
      // );
      return false;
    },
    positionsAvailability() {
      // return this.$store.getters["organization/checkExtensionAvailabilityById"](
      //   "availability.units"
      // );
      return false;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.canReadAllLeaves && this.leavesAvailabiliy) {
        await this.fetchAvailabilityCounts();
      } else {
        // Fallback to organization counts if no permission
        this.activeLeavesCount =
          this.organization.count?.totalNotAvailable || 0;
        this.totalActiveMembersCount =
          this.organization.count?.totalMemberships || 0;
        this.isLoading = false;
      }
    },
    async fetchAvailabilityCounts() {
      try {
        this.isLoading = true;
        const organizationId = this.$route.params.organizationId;
        const now = Timestamp.now();

        // Query 1: Count active leaves (start <= now AND end >= now)
        // Firestore doesn't support multiple inequality filters on different fields,
        // so we use the same approach as LeavesStatisticsOverview.vue
        const leavesCollection = collection(
          db1,
          "organizations",
          organizationId,
          "leaves",
        );

        // Get all leaves
        const allLeavesSnapshot = await getCountFromServer(leavesCollection);
        const allLeavesCount = allLeavesSnapshot.data().count;

        // Get leaves that haven't started yet (start > now)
        const futureStartQuery = query(
          leavesCollection,
          where("duration.start.timestamp", ">", now),
        );
        const futureStartSnapshot = await getCountFromServer(futureStartQuery);
        const futureStartCount = futureStartSnapshot.data().count;

        // Get leaves that already ended (end < now)
        const alreadyEndedQuery = query(
          leavesCollection,
          where("duration.end.timestamp", "<", now),
        );
        const alreadyEndedSnapshot = await getCountFromServer(
          alreadyEndedQuery,
        );
        const alreadyEndedCount = alreadyEndedSnapshot.data().count;

        // Active leaves = total - future - ended
        this.activeLeavesCount =
          allLeavesCount - futureStartCount - alreadyEndedCount;

        // Query 2: Count active members
        const membershipsCollection = collection(
          db1,
          "organizations",
          organizationId,
          "membershipsPublic",
        );

        const activeMembersQuery = query(
          membershipsCollection,
          where("access.status", "==", "activated"),
          where("user.division.id", "==", "0iBNjpwFcKQSA85j0zkf"),
        );
        const activeMembersSnapshot = await getCountFromServer(
          activeMembersQuery,
        );
        this.totalActiveMembersCount = activeMembersSnapshot.data().count;

        this.isLoading = false;
      } catch (error) {
        console.error("Error fetching availability counts:", error);
        // Fallback to organization counts on error
        this.activeLeavesCount =
          this.organization.count?.totalNotAvailable || 0;
        this.totalActiveMembersCount =
          this.organization.count?.totalMemberships || 0;
        this.isLoading = false;
      }
    },
    statusText(status) {
      switch (status) {
        case "operational":
          return "Einsatzbereit";
        case "not fully operational":
          return "Bedingt einsatzbereit";
        case "not operational":
          return "Nicht einsatzbereit";
        case "in operation":
          return "Im Einsatz";
        default:
          "";
      }
    },
    statusColor(status) {
      switch (status) {
        case "operational":
          return "green lighten-4";
        case "not fully operational":
          return "orange lighten-4";
        case "not operational":
          return "red lighten-4";
        case "in operation":
          return "blue lighten-4";
        default:
          "";
      }
    },
    statusTextColor(status) {
      switch (status) {
        case "operational":
          return "green--text";
        case "not fully operational":
          return "orange--text";
        case "not operational":
          return "red--text";
        case "in operation":
          return "blue--text";
        default:
          "";
      }
    },
  },
};
</script>
